import { render } from "./SubHeader.vue?vue&type=template&id=9cc21f88&ts=true"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"

import "./SubHeader.vue?vue&type=style&index=0&id=9cc21f88&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__